import { render } from "./OidcSilentCallback.vue?vue&type=template&id=371726ba"
import script from "./OidcSilentCallback.vue?vue&type=script&lang=js"
export * from "./OidcSilentCallback.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/OidcSilentCallback.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "371726ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('371726ba', __exports__)) {
    api.reload('371726ba', __exports__)
  }
  
  module.hot.accept("./OidcSilentCallback.vue?vue&type=template&id=371726ba", () => {
    api.rerender('371726ba', render)
  })

}


export default __exports__